import React from 'react';
import styled from 'styled-components';
import { Dark2, SwitchColor, WerfenColor } from "../../../Constants/ColorChart";
/*
 *  @Description:   Stateless component that renders a Switch
 */

const Group = styled.g`
    .switch {
	    transform: translateX(0px);
	    transition: all 300ms;
	    fill: ${Dark2}
	    &.active{
	        transform: translateX(12px);
	        fill: ${WerfenColor}
	        }
    }
`;

const Switcher = ( props ) => {
    const { isActive } = props;
    return (
        <Group className={"Switcher"}>
            <path
                className="switch_path"
                d="m21.8 12c0.023 2.17-1.77 3.96-3.98 3.96h-0.0461-11.5c-2.21 0.0226-4.03-1.74-4.03-3.91v-0.0452c-0.023-2.17 1.77-3.96 3.98-3.96h0.0461 11.5c2.21-0.0226 4.03 1.74 4.03 3.91v0.0452z"
                fill={ SwitchColor }/>
            <circle
                className={ "switch " + (isActive ? "active" : "")  }
                cx="6"
                cy="12"
                r="6"
            />
        </Group>
    )
}

export default Switcher;